module.exports = __webpack_public_path__ + "static/museum-exhibition-edefefb94994e32edcc94e454da4d98d.jpg";